import { useCallback, useEffect, useState } from 'react'
import { createAppState } from './util'
import { GQL_ENDPOINT } from '../util/consts'
import { CollectionAction } from './types'
import { GraphQLClient } from 'graphql-request'
import { loader } from 'graphql.macro'


const storiesQuery = loader('../queries/collectionStories.graphql')
const client = new GraphQLClient(GQL_ENDPOINT)

export function useCollectionStories(
  slug: string,
  type: string,
  dispatch: (action: CollectionAction) => void,
  initialActiveStorySlug: string | null
) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchStories = useCallback(async () => {
    if (!slug || !type) return

    setLoading(true)
    setError(null)

    try {
      const where = type === 'topic' ? { topics_some: { slug: slug } } : { category: { slug: slug } }

      const response = await client.request(storiesQuery, { 
        where,
        orderBy: 'title_ASC'
      })

      if (response) {
        const processedStories = createAppState(response.stories, initialActiveStorySlug)

        dispatch({
          type: 'initialize_state',
          state: processedStories,
        })
      }
    } catch (err) {
      setError(err as Error)
      console.error(err)
    } finally {
      setLoading(false)
    }
  }, [slug, type, dispatch])

  useEffect(() => {
    fetchStories()
  }, [fetchStories])

  return { loading, error }
}
